import { render, staticRenderFns } from "./ColorModuleResult.vue?vue&type=template&id=17d346a3&scoped=true"
import script from "./ColorModuleResult.vue?vue&type=script&setup=true&lang=ts"
export * from "./ColorModuleResult.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ColorModuleResult.vue?vue&type=style&index=0&id=17d346a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d346a3",
  null
  
)

export default component.exports